module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chtitle",
    attrs: {
      "id": "ch2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Motivation & inspiration",
      "src": "images/ch2.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("I wanted to get better at sketching because I paint portraits and urban landscapes. Without good sketching skills I knew I would not be able to make much progress in these areas, so I started my quest to learn how to do it properly.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The power of seeing")])]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("I am in total awe of the ability to see, and cherish the pair of eyes that I have. What if someone borrowed your eyes for a day and you were not able to see for twenty-four hours? Just imagine all the things you would have to miss – and the way you would feel when your eyes were returned. You would be more appreciative and grateful for them, and your experience with your eyes would be totally different. You would learn to use your eyes afresh and appreciate all what you can see around you in such a new way! Cherishing every opportunity to use my eyes informs how I approach my sketching.")]), _vm._v(" "), _c('p', {
    staticClass: "indents"
  }, [_vm._v("As humans, we have the power to depict what we see in a ‘drawing language’ that no other animal can do. This makes us special, and I believe we can all do this with a reasonable amount of guidance and training. My first belief as an artist is that I have the ability and the power to see whatever is before my eyes and sketch it accurately without any interference from my brain. Once again I believe we can all do it. What normally sets us back is that we have too much information about what we know about things. When it comes to the time to draw what is in front of us, we bring too much of that knowledge into the drawing experience. If we rely just on what is in front of us – without all that information in our heads – we will be able to see more clearly and better able to put it down on paper.")]), _vm._v(" "), _c('p', {
    staticClass: "indents"
  }, [_vm._v("Another way I relate to the power of seeing is in the way children see possibilities in the most mundane things. You put a child in the garden for a few minutes and they begin to explore. They look and keep looking. A single leaf becomes some sort of wonder. They pick up a stone and start grinding the leaf with the stone. They gather some twigs and all of a sudden they are cooking up something special. My questions then are these: Can you begin to see with the curiosity of a child? Can you face the world with excitement and purity of thought? Are you willing to cherish every moment and every experience as special to the point where you are fascinated with almost everything you see? If you are and if you can, then your pursuit of learning to see differently – plus your desire to do it accurately – will make you a powerful sketcher. You will tap into the real power of seeing. It is a blessing and it is a gift – so don’t take it for granted!")]), _vm._v(" "), _c('div', {
    staticClass: "bggld"
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/img-013.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/img-014.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "capc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("See, then sketch")])]), _vm._v(" "), _c('p', {
    staticClass: "capc"
  }, [_vm._v("In learning to sketch, I looked. I read art books and art magazines; I watched art DVDs, I went to art school, took art workshops and watched other artists paint and sketch. Over the years I gained an immense amount of practical knowledge on how to turn what I saw into what I draw; and this is what helped me to become a master sketcher.")])])]), _c('div', {
    staticClass: "gnbox"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('p', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("Attitude in public")])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "noindents"
  }, [_vm._v("When sketching in any public space there are a few things that really help to make your adventure a pleasant one.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "hng"
  }, [_vm._v("•")]), _vm._v(" Always be grateful to those who take the time to come over to where you are sketching and pass a comment about your work. Whether complimentary or derogatory, be thankful that they felt moved enough to approach you in the first place.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "hng"
  }, [_vm._v("•")]), _vm._v(" Always ask permission to sketch in places like museums, galleries or hospitals. People are generally okay but it is always good to be sure. Follow your gut feeling.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "hng"
  }, [_vm._v("•")]), _vm._v(" If someone asks what you are doing, or why, give them your sketchbook and let them have a look while you explain. This gives them the power and they will be more likely to listen and be reassured.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "hng"
  }, [_vm._v("•")]), _vm._v(" Keep a simple smile or a pleasant disposition as you sketch in public. People feel more relaxed around you this way. If possible, show you really are in awe of what you are sketching. That alone can keeps onlookers absorbed in wonder at what a great time you are having.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "hng"
  }, [_vm._v("•")]), _vm._v(" There’s no need to speak to everyone around you if you find it distracting, but make sure you do your best to respond to those who make an effort to greet you.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "hng"
  }, [_vm._v("•")]), _vm._v(" If the person you are sketching frowns or asks you to stop, be polite and respect their wishes.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "hng"
  }, [_vm._v("•")]), _vm._v(" While sketching on trains I generally do not ask permission from all the passengers – if I did that I would never get anything done! However, as I sketch, I smile to try to make onlookers feel relaxed.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "hng"
  }, [_vm._v("•")]), _vm._v(" If you are starting off sketching people on public transport, sketch the people who are sleeping or who are firmly glued to their smartphones and tablets; they are the best and will help you build your confidence.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "hng"
  }, [_vm._v("•")]), _vm._v(" If you are sketching a homeless person or a busker, let them know what you are doing from the start, and ask permission politely. A generous tip or donation will likely give you sure access to a happy and very co-operative model.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "hng"
  }, [_vm._v("•")]), _vm._v(" Never be aggressive or rude to anyone in public. If you are tried and tested beyond your limit, call for help. It is better that way than to be seen as a mad artist – and it will help make it easier and safer for the rest of us.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "hng"
  }, [_vm._v("•")]), _vm._v(" If you are sketching at night, wear a bright, visible jacket. Keep your phone on you and take a torch. Most smartphones have torches.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "hng"
  }, [_vm._v("•")]), _vm._v(" Keep the environment clean. Do not leave scraps of paper, tissue or pencil shavings after you. Take a small bin bag with you for all your mess.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "hng"
  }, [_vm._v("•")]), _vm._v(" On a train, where you sit really matters. To get lots of sketches done, avoid sitting in the direction in which the train is moving, because most people sit that way. I love to sit at an angle where I can see and sketch without being too obtrusive. You don’t want to be in people’s faces.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "hng"
  }, [_vm._v("•")]), _vm._v(" If you are not comfortable with people looking over your shoulders while sketching in public, find a wall that you can lean against so that no one can sneak up on you from behind.")]), _vm._v(" "), _c('div', {
    staticClass: "tspace"
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/img-015.jpg"
    }
  })])])])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("What will keep you going?")])])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('p', {
    staticClass: "noindents"
  }, [_vm._v("Everybody starts out with enthusiasm when they are excited about a new venture, but how many remain in that frame of mind in the middle of the project? To thrive creatively, you need to be tough. My advice is to remember what started you off in the first place. I constantly remind myself of the joy of being able to observe the world around me, and my intense curiosity to improve my drawing skills. Drawing never gets easier, so it is best to see it as an ongoing goal; one that will always demand practice. Because of this demand, I developed a motto: ‘sketch, sketch, sketch, draw, draw and draw.’ This single phrase has kept me going.")]), _vm._v(" "), _c('p', {
    staticClass: "indents"
  }, [_vm._v("A strong ‘why?’ in any venture is a most powerful tool in getting results. My ‘why’ is that I want to share my passion for sketching with the world. I see myself as a prophet of sketching, looking for disciples who will feel the same thrills that I enjoy when drawing.")]), _vm._v(" "), _c('p', {
    staticClass: "indents"
  }, [_vm._v("The third thing that keeps me going is just pure passion: the sincere love I have for good sketching and great drawing. I love when it is done well with a level of mastery. You can almost feel the page come to life when someone sketches something with deep intensity and feeling. I love to look at a plain page spread in my sketchbook and know that by the end of the day, it will be filled up with images that no-one but me will bring to life! Even when I am tired, I say to myself, ‘Bring one more thing to life today; just one more.’ It may just be a face, but that face would not exist if I didn’t try. It is all about passion; but it requires work, effort and persistence to bring the passion to life.")]), _vm._v(" "), _c('p', {
    staticClass: "indents"
  }, [_vm._v("One final thing: I am obsessed with the books and DVDs of the artists I admire. Make sure you stock up on works that inspire you. On days when you don’t feel like sketching, you can go into your archive to read and absorb the writings and images of the artists you love.")]), _vm._v(" "), _c('p', {
    staticClass: "indents"
  }, [_vm._v("Obstacles are what you see when you lose sight of your goals. I implore you to never stop going.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("My inspiration")]), _vm._v(" "), _c('p', {
    staticClass: "ipara"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("I’ll pick up a book – any book – on John Singer Sargent, Anders Zorn, Joaquin Sorolla, Richard Schmid, Scott Burdick, Peter Brown, Quang Ho, Morgan Weistling, Susan Lyon, John Howard Sanden, Everett Raymond Kinstler, Scott Christensen, Ken Howard, Zhuo Shu Liang, Rose Frantzen, Trevor Chamberlain, Tim Okamura, Abiodun Olaku, Edosa Ogiugo, Leonardo da Vinci, Rembrandt, Velazquez, Diarmuid Kelly, and Andrew Festing. Just going through these artists’ books, drawings, paintings or studies are enough to whet my appetite and fire me up! I never remain the same after a good bath in their realms.")])]), _vm._v(" "), _c('div', {
    staticClass: "tspace"
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/img-016.jpg"
    }
  })])])]), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Pitfalls and challenges")])])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "noindents"
  }, [_vm._v("There is a time in every project when the whole reason you started it will die. Be ready for this mini funeral: it will come. Once you recognize this, you can prepare for it – and then it will be easy to say, ‘I knew this was coming, and I know you are not going to stay dead for long: there is a resurrection day too and I’m expecting that any time from now.’")]), _vm._v(" "), _c('p', {
    staticClass: "indents"
  }, [_vm._v("Once you can treat this period this way, you will know it is not the end of the project, but just a period where you can prepare for its resurrection. Plan for that period, know how you are going to encourage yourself – and have it written down nearby!")]), _vm._v(" "), _c('p', {
    staticClass: "h4"
  }, [_vm._v("HOW TO OVERCOME CHALLENGES AND MAINTAIN MOMENTUM")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "hng"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Maintain your course")]), _vm._v(" Never compare the pace of your development with other artists’, it is deadly. Use other artists to fuel your passion, but certainly not for comparison.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "hng"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Don’t take yourself too seriously")]), _vm._v(" Sketching should always be mostly fun to do. Whenever a sketch does not work out as expected, remember to say, ‘Hey, it’s only a sketch’.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "hng"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Keep everything")]), _vm._v(" Never tear out a page from your sketchbook because it was not successful in your eyes. That would be too negative. If it didn’t work, move to the next page. If they are torn out, how would you measure your progress and learn from your errors?")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "hng"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Avoid comparisons")]), _vm._v(" Use of social media is great but bear in mind that no-one posts their failures. Remember, there are thousands of artists that are better than you and thousands more that you are better than. Don’t let anything you see there make you depressed or overconfident.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "hng"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Avoid financial pressure")]), _vm._v(" When it comes to the artistic process and pursuit, never make your art the main source of your income when just starting out. Do other things to support your art, things that will take the pressure off you a bit, and that will allow you to practise on a consistent basis. No one ever thrived in the creative area with a pile of debt.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "hng"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Start from the beginning")]), _vm._v(" If you are waiting to be perfect, you will surely wait for a very long time. You will never be ready to show your work to the world, or advertize your sketch book to the masses. Start from where you are, and allow yourself space to thrive.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "hng"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Make space")]), _vm._v(" It is easy to get discouraged or distracted. Carve out a tiny haven at home or in your studio, where you are going to be able to work. Create an uncluttered place where you can just start sketching or drawing and make sure you keep to a particular time. For instance, if you have a day job, the early hours of the morning might be best and if you finish work a bit early, you might want to work on your passion afterwards. It does not have to be every day or for very long, but make sure it is a routine you can stick to.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "hng"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Develop your habit")]), _vm._v(" Never focus on trying to do a good sketch. Instead, focus on developing the habit of sketching. This will relieve you from the pressure of perfection and help you to keep going when you don’t feel like it.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "hng"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Avoid negativity")]), _vm._v(" Be aware that the world is full of critics; they will gravitate towards you. Be careful not to let their derogatory comments affect your artistic stamina. Focus on what matters, and trash the rest.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "hng"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Cultivate a healthy mind")]), _vm._v(" Fill your mind with motivational quotes and material from personal development books that you know will help you to keep your mind healthy. You must have the right mindset when you venture into anything creative, so don’t lose the battle in your mind.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "hng"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Plan")]), _vm._v(" Maintain a clear developmental plan to succeed and stick to that. That may mean you attend workshops, one-to-one sessions, art courses or art conventions where your favourite artists come together to demonstrate and explain their practice and skills.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "hng"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Get support")]), _vm._v(" When things are not going well, as sometimes happens, do not resort to anything destructive – too much drinking or smoking will just make things worse. Anything that you know is not going to serve your health is best to avoid. What most of us need while we are on this creative journey is a good network of supportive friends, plenty of rest and time to meditate and exercise, with some real good nutritious meals. Surround yourself with people who care, and avoid focussing too much on yourself: it’s dangerous.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "hng"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Find the right feedback")]), _vm._v(" Competitions, awards, bursaries, residencies, open exhibitions, juried exhibitions and even sales are all good in that they help you by giving you feedback, revenue and some exposure, but never rely on their rejections or acceptances as a yardstick to measure your progress. What matters most is for you to make steady progress. This can easily be assessed by you, a trusted friend or teacher you know, who will really give you some positive feedback.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f66d497","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/09_Chapter02.vue
// module id = 84
// module chunks = 0